module.exports = __webpack_public_path__ + "static/img/logo_guangming.76124bbf.png";